export default __webpack_public_path__ + "42dda3008ffd469c40e457d727087770.svg";